<template>
  <div class="password">
    <div class="password__modal">
      <form>
        <div class="password__modal--close">
          <div @click="passwordCancel">
            <font-awesome-icon icon="times" />
          </div>
        </div>
        <div class="password__modal--header">Change Account Password</div>
        <div class="password__modal--fields">
          <div>
            <div class="password__modal--fields-text">New Password:</div>
            <div class="password__modal--fields-input">
              <input type="password" v-model="newPassword" />
            </div>
          </div>
          <div>
            <div class="password__modal--fields-text">Confirm New Password:</div>
            <div class="password__modal--fields-input">
              <input type="password" v-model="confirmNewPassword" />
            </div>
          </div>
        </div>
        <div class="password__modal--error">
          <span v-show="passwordError">All fields are required.</span>
          <span v-show="spaceError">Password must not have space.</span>
          <span v-show="identityError">Your new password cannot be confirmed.</span>
          <span v-show="LengthError">New password must not be less than 8 characters.</span>
          <span v-show="successMsg">Password changed successfully.</span>
          <span v-show="networkError">An error occured. Please try again.</span>
        </div>
        <div class="password__modal--btn">
          <button
            class="password__modal--btn-left"
            v-show="!loader"
            @click.prevent="changePassword"
          >Save Settings</button>
          <button class="password__modal--btn-left" v-show="loader">
            <WhiteLoader />
          </button>
          <div class="password__modal--btn-right" @click="passwordCancel">Cancel</div>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import * as types from "../../../store/constant";
import WhiteLoader from "../../partials/white-loader";

export default {
  name: "ChangePassword",
  components: {
    WhiteLoader
  },
  props: ["selectedAdmin"],
  data() {
    return {
      loader: false,
      wrongPassword: false,
      passwordError: false,
      spaceError: false,
      LengthError: false,
      identityError: false,
      successMsg: false,
      networkError: false,
      newPassword: "",
      confirmNewPassword: ""
    };
  },
  methods: {
    passwordCancel() {
      this.loading = false;
      this.wrongPassword = false;
      this.passwordError = false;
      this.spaceError = false;
      this.LengthError = false;
      this.identityError = false;
      this.successMsg = false;
      this.networkError = false;
      this.$emit("closePasswordModal");
    },
    changePassword() {
      this.wrongPassword = false;
      this.passwordError = false;
      this.spaceError = false;
      this.LengthError = false;
      this.identityError = false;
      this.successMsg = false;
      this.networkError = false;

      if (
        this.newPassword.trim() === "" ||
        this.confirmNewPassword.trim() === ""
      ) {
        this.passwordError = true;
        return;
      }

      if (
        /\s/.test(this.newPassword.trim()) ||
        /\s/.test(this.confirmNewPassword.trim())
      ) {
        this.spaceError = true;
        return;
      }

      if (this.newPassword.trim().length < 8) {
        this.LengthError = true;
        return;
      }

      if (this.newPassword.trim() !== this.confirmNewPassword.trim()) {
        this.identityError = true;
        return;
      }

      this.loader = true;

      const formDetails = {
        new_password: this.newPassword,
        password_confirm: this.confirmNewPassword,
        id: parseInt(this.selectedAdmin, 10)
      };

      this.$http
        .put(`${types.ADMIN_API}/${this.selectedAdmin}`, formDetails)
        .then(() => {
          this.successMsg = true;
          this.newPassword = "";
          this.confirmNewPassword = "";
          this.newPassword = "";
          this.confirmNewPassword = "";
          this.loader = false;
        })
        .catch(error => {
          this.loader = false;
          if (error.response.status === 500) {
            this.networkError = true;
          } else {
            this.wrongPassword = true;
          }
        });
    }
  }
};
</script>

<style lang="scss" scoped>
.password {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(112, 112, 112, 0.71);
  padding: 82px 13.854vw 100px 13.854vw;
  overflow: auto;

  > .password__modal {
    width: 67.604vw;
    margin: 0 auto;
    padding-top: 50px;
    padding-bottom: 100px;
    border-radius: 2px;
    box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.1);
    background-color: #ffffff;
    padding-left: 13.021vw;
    padding-right: 13.021vw;

    > form {
      .password__modal--close {
        overflow: hidden;

        > div {
          width: 24px;
          height: 24px;
          float: right;
          text-align: right;
          cursor: pointer;
        }
      }

      .password__modal--header {
        font-size: 1.458vw;
        font-weight: 500;
        font-style: normal;
        font-stretch: normal;
        line-height: 1.43;
        letter-spacing: normal;
        text-align: center;
        color: #000000;
        margin-top: 50px;
      }

      .password__modal--fields {
        margin: 20px 0;
        > div {
          display: flex;
          flex-direction: row;
          flex-wrap: nowrap;
          align-items: center;
          justify-content: space-between;
          align-content: center;
          margin: 30px 0 10px 0;

          .password__modal--fields-text {
            width: 13.021vw;
            font-size: 14px;
            font-weight: normal;
            font-style: normal;
            font-stretch: normal;
            line-height: 1.17;
            letter-spacing: normal;
            text-align: left;
            color: #000000;
          }
          .password__modal--fields-input {
            width: calc(100% - 13.021vw);
            height: 40px;
            border: solid 1px #c7c7c7;
            background-color: #ffffff;
            overflow: hidden;

            > input {
              height: 40px;
              background-color: #ffffff;
              border: 0;
              outline: none;
              padding: 0 10px;
            }
          }
        }
      }

      .password__modal--error {
        height: 30px;
        text-align: center;

        > span {
          font-size: 0.938vw;
          font-weight: normal;
          font-style: normal;
          font-stretch: normal;
          letter-spacing: normal;
          text-align: left;
          color: red;
          margin-top: 10px;
          font-style: italic;
        }
      }

      .password__modal--btn {
        display: flex;
        flex-direction: row;
        flex-wrap: nowrap;
        align-items: center;
        justify-content: space-between;
        align-content: center;
        width: 270px;
        margin: auto;

        > .password__modal--btn-left {
          width: 9.063vw;
          height: 41px;
          border-radius: 5px;
          background-color: #5099de;
          font-size: 0.781vw;
          font-weight: normal;
          font-style: normal;
          font-stretch: normal;
          line-height: 1.2;
          letter-spacing: normal;
          text-align: center;
          color: #ffffff;
          display: flex;
          flex-direction: row;
          flex-wrap: nowrap;
          align-items: center;
          justify-content: center;
          align-content: center;
          cursor: pointer;
          border: 0;
          outline: 0;
        }

        > .password__modal--btn-right {
          width: 9.063vw;
          height: 41px;
          border-radius: 5px;
          background-color: #dcdcdc;
          font-size: 0.781vw;
          font-weight: normal;
          font-style: normal;
          font-stretch: normal;
          line-height: 1.2;
          letter-spacing: normal;
          text-align: center;
          color: #000000;
          display: flex;
          flex-direction: row;
          flex-wrap: nowrap;
          align-items: center;
          justify-content: center;
          align-content: center;
          cursor: pointer;
        }
      }
    }
  }
}
</style>
